
import {defineComponent} from 'vue';
import {Order} from '../types';
import TableHeaderSortDropdown from './TableHeaderSortDropdown.vue';

export default defineComponent({
  name: 'oxd-card-th',

  props: {
    order: {
      type: String,
      required: false,
    },
  },

  emits: ['order'],

  components: {
    'oxd-card-th-sort': TableHeaderSortDropdown,
  },

  methods: {
    onOrder(order: Order) {
      this.$emit('order', order);
    },
  },
});
